import React from 'react'
import Icon from 'react-icon-base'

const ArrowLeftIcon = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g>
      <path d="m33.2 18.4v3.2h-20.3l9.3 9.4-2.3 2.4-13.4-13.4 13.4-13.4 2.4 2.4-9.4 9.4h20.3z" />
    </g>
  </Icon>
)

export default ArrowLeftIcon
